export const SITE_BRAND = {
  LOKSY: 'loksy',
  KNLS: 'knls',
  ALL: 'all',
};

function hostnameFrom(host) {
  return String(host || '')
    .split(':')[0]
    .trim()
    .toLowerCase();
}

export function brandFromHost(host) {
  const hostname = hostnameFrom(host);
  if (hostname === 'loksy.in' || hostname === 'www.loksy.in') {
    return SITE_BRAND.LOKSY;
  }
  if (hostname === 'knls.in' || hostname.endsWith('.knls.in')) {
    return SITE_BRAND.KNLS;
  }
  return SITE_BRAND.ALL;
}

export function getPublicSiteBrand() {
  if (typeof window === 'undefined') return SITE_BRAND.ALL;
  return brandFromHost(window.location.hostname);
}

export function showLoksyApps(brand = getPublicSiteBrand()) {
  return brand !== SITE_BRAND.KNLS;
}

export function showKnlsLms(brand = getPublicSiteBrand()) {
  return brand !== SITE_BRAND.LOKSY;
}
